import { Sparkles } from 'lucide-react';
import { Download2Line } from '@archipro-design/icons';
import { useTracker } from '@archipro-website/tracker';
import { useBoostControl } from '@modules/page-builder/component/common/upscale-warning/boost-control-context';
import { encodeDownloadLink } from '@modules/page-builder/component/detail/detail-single-image-shell/HoverButtonsImage';
import { TileActionIconButton } from '~/modules/moodboards/components/TileActionIconButton';

/**
 * The staff tools over a revamp hero's banner — Boost Resolution and Download
 * — in the same row of discs the photographs below carry, so the banner reads
 * as the first of them rather than as a legacy banner with its old buttons.
 *
 * Drawn inside a `BoostResolutionOverlay` set to `controlInActionPanel`, which
 * hands Boost down through context; outside one, or for a reader who cannot
 * boost, only Download shows. Comes up on hover of the `group/hero` around it.
 */
export const HeroImageActions = ({
    downloadLink,
    libraryImageId,
}: {
    /** The banner as a file, for a reader allowed to take it. */
    downloadLink?: string;
    libraryImageId: number;
}) => {
    const boost = useBoostControl();
    const tracker = useTracker();
    if (!boost && !downloadLink) return null;

    return (
        <div className="pointer-events-none absolute inset-x-0 bottom-8 z-10 flex justify-center gap-2 opacity-0 transition-opacity duration-200 group-hover/hero:pointer-events-auto group-hover/hero:opacity-100">
            {boost ? (
                <TileActionIconButton
                    label={
                        boost.wasUpscaled ? 'Compare boost' : 'Boost Resolution'
                    }
                    icon={<Sparkles />}
                    onClick={boost.activate}
                />
            ) : null}
            {downloadLink ? (
                <TileActionIconButton
                    label="Download"
                    icon={<Download2Line />}
                    href={encodeDownloadLink(downloadLink)}
                    download
                    onClick={() => {
                        tracker.log('StaffDownloadImage', {
                            url: new URL(window.location.href),
                            data: { LibraryImageID: libraryImageId },
                        });
                    }}
                />
            ) : null}
        </div>
    );
};
